import { useAppsWs } from '../../../../../../../Layout/Header/components/Profile/components/Apps/hooks/useAppsWs';
export var useApps = function (_a) {
    var accessToken = _a.accessToken;
    var apps = useAppsWs({ accessToken: accessToken }).apps;
    return {
        apps: apps,
    };
};
//# sourceMappingURL=useApps.js.map